import React from 'react';
import { CTAButton } from './CTAButton';
export const ProblemSection = () => {
  return <section className="w-full bg-white py-16 px-4 md:px-8 lg:px-16" data-id="element-132">
      <div className="max-w-6xl mx-auto" data-id="element-133">
        <div className="text-center mb-12" data-id="element-134">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-135">
            Syndrom Niewidzialnej Żony po 40
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-136">
            Czy zauważyłaś, że Twój mąż przestał Cię dostrzegać? Nie chodzi
            tylko o brak seksu, ale o coś głębszego - jakbyś powoli znikała z
            jego pola widzenia. To nie przypadek - to doświadczenie dzielone
            przez tysiące kobiet po 40-tce.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-137">
          {/* Faza Znikanie */}
          <div className="bg-[#faf7f2] rounded-lg p-6 shadow-md" data-id="element-138">
            <h3 className="font-serif text-2xl font-bold text-gray-800 mb-4" data-id="element-139">
              Faza Znikania
            </h3>
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAzhmHpBJx5Ijw6qBLncDydWXbzMk0K1QgRHtV" alt="Kobieta zajęta codziennymi obowiązkami" className="w-full h-64 object-cover rounded-md mb-4" data-id="element-140" />
            <p className="text-gray-700 mb-4" data-id="element-141">
              Najpierw stajesz się "tłem" - jesteś mamą, gospodynią,
              organizatorką, ale przestajesz być KOBIETĄ w jego oczach. Twoje
              potrzeby schodzą na dalszy plan, a Ty sama zaczynasz wierzyć, że
              tak musi być.
            </p>
            <blockquote className="border-l-4 border-red-500 pl-4 italic text-gray-600" data-id="element-142">
              "Byłam tak zajęta wszystkimi i wszystkim, że zapomniałam o sobie.
              A mój mąż... po prostu przestał mnie widzieć." - Anna, 45 lat
            </blockquote>
          </div>
          {/* Faza Desperacja */}
          <div className="bg-[#faf7f2] rounded-lg p-6 shadow-md" data-id="element-143">
            <h3 className="font-serif text-2xl font-bold text-gray-800 mb-4" data-id="element-144">
              Faza Desperacji
            </h3>
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rA5PuShWQ9aCbszYjnNAMpcH4ZSRJuDqwErWF3" alt="Kobieta próbująca zwrócić uwagę męża" className="w-full h-64 object-cover rounded-md mb-4" data-id="element-145" />
            <p className="text-gray-700 mb-4" data-id="element-146">
              Zaczynasz walczyć o uwagę - kupujesz nowe ubrania, zmieniasz
              fryzurę, inicjujesz rozmowy. Ale im bardziej się starasz, tym
              bardziej on się oddala. Każda próba kończy się rozczarowaniem.
            </p>
            <blockquote className="border-l-4 border-red-500 pl-4 italic text-gray-600" data-id="element-147">
              "Kupiłam seksowną bieliznę, zrobiłam makijaż... a on nawet nie
              podniósł wzroku znad telefonu. Czułam się jak powietrze." -
              Monika, 43 lata
            </blockquote>
          </div>
          {/* Błędne Koło Odrzucenia */}
          <div className="bg-[#faf7f2] rounded-lg p-6 shadow-md" data-id="element-148">
            <h3 className="font-serif text-2xl font-bold text-gray-800 mb-4" data-id="element-149">
              Błędne Koło Odrzucenia
            </h3>
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rATZ5iCASglikGyo4PnhLmpEUzOJQsF0VtuZqx" alt="Kobieta z wyrazem rezygnacji" className="w-full h-64 object-cover rounded-md mb-4" data-id="element-150" />
            <p className="text-gray-700 mb-4" data-id="element-151">
              W końcu poddajesz się. Rezygnacja prowadzi do jeszcze większej
              niewidzialności, a ta do głębszego odrzucenia. Koło się zamyka, a
              Ty czujesz się coraz bardziej samotna - mimo że nie jesteś sama.
            </p>
            <blockquote className="border-l-4 border-red-500 pl-4 italic text-gray-600" data-id="element-152">
              "Przestałam próbować. Po co? I tak nic nie działało. Mieszkamy
              razem, ale żyjemy osobno." - Dorota, 49 lat
            </blockquote>
          </div>
        </div>
        <div className="text-center mt-10" data-id="element-153">
          <CTAButton text="Chcę przerwać Błędne Koło" data-id="element-154" />
        </div>
      </div>
    </section>;
};